import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { datumMezoEvUgras } from './app/datum-mezo-ev';

if (environment.production) {
  enableProdMode();
}

// A dátummezőkben az év 4 számjegye után a hónapra lépjen (lásd datum-mezo-ev.ts).
datumMezoEvUgras();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
